import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["id", "leftIcon", "rightIcon", "hasError", "hasSuccess", "className"],
      _excluded2 = ["leftIcon", "rightIcon", "id", "hasError", "hasSuccess", "type", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React, { forwardRef } from 'react';
import formStyles from '../styles.module.scss';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InputElement = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    id,
    leftIcon,
    rightIcon,
    hasError,
    hasSuccess,
    className
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({}, id && {
    id
  }), {}, {
    ref: ref,
    className: clsx(formStyles.input, styles.input, leftIcon && styles['input--leftIcon'], rightIcon && styles['input--rightIcon'], hasError && formStyles['input--hasError'], hasSuccess && formStyles['input--hasSuccess'], className || '')
  }, props));
});
InputElement.displayName = 'InputElement';
const Input = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    leftIcon,
    rightIcon,
    id = '',
    hasError = false,
    hasSuccess = false,
    type = 'text',
    className = ''
  } = _ref2,
      props = _objectWithoutProperties(_ref2, _excluded2);

  if (!leftIcon && !rightIcon) {
    return /*#__PURE__*/_jsx(InputElement, _objectSpread(_objectSpread(_objectSpread({}, id && {
      id
    }), className && {
      className
    }), {}, {
      ref: ref,
      hasError: hasError,
      hasSuccess: hasSuccess,
      type: type,
      rightIcon: rightIcon,
      leftIcon: leftIcon
    }, props));
  } // Add wrapper around input for icon(s)


  return /*#__PURE__*/_jsxs("div", {
    ref: ref,
    className: styles.container,
    children: [leftIcon && /*#__PURE__*/_jsx("span", {
      className: clsx(styles.container__icon, styles['container__icon--left']),
      children: leftIcon
    }), /*#__PURE__*/_jsx(InputElement, _objectSpread(_objectSpread(_objectSpread({}, id && {
      id
    }), className && {
      className
    }), {}, {
      hasError: hasError,
      hasSuccess: hasSuccess,
      type: type,
      rightIcon: rightIcon,
      leftIcon: leftIcon
    }, props)), rightIcon && /*#__PURE__*/_jsx("span", {
      className: clsx(styles.container__icon, styles['container__icon--right']),
      children: rightIcon
    })]
  });
});
Input.displayName = 'Input';
export default Input;